import React from 'react'
import styled from 'styled-components'
import { Modal } from './Modal'
import { useAppSelector } from '../../hooks/useAppSelector'
import { RootState } from '../../states/store'
import { STYLES } from '../../static/style'

const MessagePanel = styled.div`
  padding: 5rem 2rem;
  text-align: center;
  font-size: ${STYLES.FONT_SIZE_LG};
  line-height: ${STYLES.HEADER_2_LINE_HEIGHT};
  font-weight: ${STYLES.FONT_WEIGHT_BOLD};
`

const MessageModal = () => {
  const {
    data: { message, header },
  } = useAppSelector((rootState: RootState) => rootState.modals)
  return (
    <Modal maxWidth={25} header={header}>
      <MessagePanel>{message}</MessagePanel>
    </Modal>
  )
}

export default MessageModal
